import * as React from 'react';
import { useMediaQuery } from '../hooks';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import Image from '../Image/Image';
import Text from '../Text/Text';

export interface Props extends FlexProps {}

/**
 * A composite component used as a placeholder page for when there
 * is a 404 page cannot be found error.
 */
const Status404: React.FunctionComponent<Props> = (props: Props) => {
  const match = useMediaQuery(['65rem']);

  return (
    <Flex { ...props }>
      <Flex
          alignChildren="middle"
          direction={ match('65rem') ? 'horizontal' : 'vertical' }
          gap={ match('65rem') ? 'x8' : 'x4' }
          paddingHorizontal="x6">
        <Text align="middle" config="1">
          404
        </Text>
        <Text align="middle" config="3">
          The coordinates you are looking for do not exist
        </Text>
      </Flex>

      <Flex container grow height="33.125rem" overflow="hidden">
        <Image
            absolute="center"
            height="530px"
            src="https://bitrise-bitkit.s3.us-east-2.amazonaws.com/assets/Status404.svg"/>
      </Flex>
    </Flex>
  );
};

export default Status404;
